import { lazy, type ComponentType } from 'react'

/**
 * React.lazy com uma tentativa de recuperação para deploy por zip (docs/RELEASE.md).
 *
 * Após um release/rollback os chunks com hash antigo deixam de existir no Amplify. Uma aba aberta
 * que navegue para uma rota ainda não carregada pede um chunk que sumiu e o `import()` rejeita.
 * Aqui: recarrega a página UMA vez (guarda em sessionStorage por chunk) e registra o evento;
 * se falhar de novo, propaga o erro para o ErrorBoundary/Suspense.
 */
export function lazyWithRetry<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>, chunkId: string) {
  return lazy(async () => {
    const key = `lazy-retry:${chunkId}`
    try {
      const mod = await factory()
      sessionStorage.removeItem(key)
      return mod
    } catch (err) {
      if (typeof window !== 'undefined' && !sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, String(Date.now()))
        window.dataLayer?.push({ event: 'chunk_reload', chunk: chunkId })
        window.location.reload()
        // a recarga interrompe a execução; retorna uma promessa pendente para o Suspense não piscar erro
        return new Promise<never>(() => {})
      }
      throw err
    }
  })
}
